import { render, staticRenderFns } from "./CompanyDiscreteSlider.vue?vue&type=template&id=94672834&scoped=true&"
import script from "./CompanyDiscreteSlider.vue?vue&type=script&lang=js&"
export * from "./CompanyDiscreteSlider.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDiscreteSlider.vue?vue&type=style&index=0&id=94672834&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94672834",
  null
  
)

export default component.exports